import api from './api'

// JWT auth against the backend's own /api/v1/auth endpoints (Authentik removed
// in R1.0 Phase A). The token lives in localStorage under 'auth_token' — the
// shared axios instance in api.js reads that key and adds the Bearer header.
const TOKEN_KEY = 'auth_token'

export const auth = {
  // POST /v1/auth/login — OAuth2 password form (username = email).
  login: async (email, password) => {
    const body = new URLSearchParams()
    body.set('username', email)
    body.set('password', password)
    const r = await api.post('/v1/auth/login', body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    localStorage.setItem(TOKEN_KEY, r.data.access_token)
    return r.data
  },

  // POST /v1/auth/register — JSON body. address/phone feed the account
  // profile (contact_info) for GIIW letter pre-fill.
  register: async (email, fullName, password, address, phone) => {
    const r = await api.post('/v1/auth/register', {
      email,
      full_name: fullName,
      password,
      address: address || null,
      phone: phone || null,
    })
    return r.data
  },

  // Account profile (contact_info) — same JSON the toolkit's contact uses.
  getProfile: async () => {
    const r = await api.get('/v1/auth/profile')
    return r.data
  },

  putProfile: async (profile) => {
    const r = await api.put('/v1/auth/profile', profile)
    return r.data
  },

  // DELETE /v1/auth/me — password re-verified server-side.
  deleteAccount: async (password) => {
    await api.delete('/v1/auth/me', { data: { password } })
    localStorage.removeItem(TOKEN_KEY)
  },

  // GET /v1/auth/me — current user (Bearer header via interceptor).
  me: async () => {
    const r = await api.get('/v1/auth/me')
    return r.data
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY)
  },

  isAuthenticated: () => !!localStorage.getItem(TOKEN_KEY),
}

export default auth
